(function ($) {
    "use strict";
    $(function () {

        var isContactButtonClick = false;

        $('.js-contact-form').submit(function (e) {
            e.preventDefault();

            if (isContactButtonClick) {
                return false;
            }

            isContactButtonClick = true;

            var $this = $(this);
            grecaptcha.ready(function () {
                grecaptcha.execute(localize.captcha_site_key, { action: 'submit' }).then(function (grecaptchatoken) {
                    $.ajax({
                        type: "post",
                        context: this,
                        dataType: "json",
                        url: localize.ajaxurl,
                        data: {
                            action: "contact_form_subscribe",
                            datas: $this.serializeArray(),
                            grecaptchatoken: grecaptchatoken
                        },
                        success: function (response) {
                            isContactButtonClick = false;



                            if (!response['fault']) {
                                $this.trigger('reset');

                                if ($('#contact__success_modal').length) {
                                    Fancybox.show([{
                                        src: "#contact__success_modal",
                                        type: "inline",
                                        closeButton: false,
                                        hideScrollbar: true
                                    }]);
                                }

                            } else {

                                if (response['msg_type'] == "error") {

                                    if (response['error_fields'] && response['error_fields'].length > 0) {
                                        $.each(response['error_fields'], function (i, e) {
                                            $(`#${e}`).parents('.form-group').addClass('has--error js-has-error')

                                        })
                                    }


                                    $('.js-error-messages').html(response['msg'].map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                                        Fancybox.show([{
                                            src: "#general__error_modal",
                                            type: "inline",
                                            closeButton: false,
                                            hideScrollbar: true
                                        }]);
                                    });
                                }


                                if (response['msg_type'] == "warning") {
                                    $('.js-warning-messages').html(response['msg'].map(e => `<p class="modal__messages">${e}</p>`).join('')).promise().done(function (e) {
                                        Fancybox.show([{
                                            src: "#general__warning_modal",
                                            type: "inline",
                                            closeButton: false,
                                            hideScrollbar: true
                                        }]);
                                    });
                                }


                            }
                        }
                    });
                });
            });

            return false;
        });

    });
})(jQuery)